import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { pick } from 'lodash';

// import { Link } from 'react-router-dom';
import {
  Modal,
  ModalBody
} from 'reactstrap';

import ModalHeader from '../reactstrap/ModalHeader';



// import Loading from '../helpers/Loading';
import ProjectForm from './form';

import { addProjectSuccess, loadProject } from '../../actions';
import { Project } from '../../api'

const mapStateToProps = state => ({});

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ addProjectSuccess, loadProject }, dispatch)
};


const modalPropKeys = Object.keys(Modal.propTypes);

class NewProjectModal extends Component {
  
  onSuccess(res) {
    const { addProjectSuccess, toggle, onSuccess, loadProject} = this.props; 
    addProjectSuccess(res);
    loadProject(res.id);
    
    if ( onSuccess && typeof onSuccess === 'function')
      onSuccess(res)
    
    toggle();
  }
  
  render() {
    const { toggle, ...otherProps } = this.props;
    const modalProps = pick(otherProps, modalPropKeys);
    
    return (
      <Modal {...modalProps} centered={true}>
        <ModalHeader toggle={toggle}>Create New Project</ModalHeader>
        <ModalBody>
          <ProjectForm onSubmit={Project.create} onSuccess={this.onSuccess.bind(this)} />  
        </ModalBody>
      </Modal>
    );
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(NewProjectModal);


// WEBPACK FOOTER //
// ./src/components/Projects/newModal.js